/* unplugin-vue-components disabled */import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "bar-echart"
};
import BaseEchart from '@/base-ui/echart';
export default /*#__PURE__*/_defineComponent({
  __name: 'bar-echart-mul',
  props: {
    lineData: {},
    xLabels: {},
    legendData: {},
    colors: {},
    grid: {
      default: function _default() {
        return {
          left: 60,
          top: 60,
          bottom: 30,
          right: 20
        };
      }
    },
    customTooltip: {
      type: Boolean,
      default: false
    },
    legendShow: {
      type: Boolean,
      default: true
    },
    tooptipFormatter: {},
    legendBottom: {
      default: 'auto'
    }
  },
  emits: ["click"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    // import * as echarts from 'echarts'
    var props = __props;
    var emit = __emit;
    window.toDetail = function (params) {
      emit('click', params);
    };
    var options = computed(function () {
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          position: ['30%', '20%'],
          enterable: false,
          formatter: function formatter(p) {
            return console.log(p);
          }
        },
        legend: {
          show: props.legendShow,
          data: props.legendData,
          icon: 'circle',
          bottom: props.legendBottom
        },
        grid: props.grid,
        xAxis: {
          data: props.xLabels,
          axisLabel: {
            color: '#999999'
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          z: 10
        },
        yAxis: {
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#999'
          }
        },
        dataZoom: [{
          type: 'inside'
        }],
        series: []
      };
      if (props.customTooltip) {
        option.tooltip.enterable = true;
        if (props.tooptipFormatter) {
          option.tooltip.formatter = props.tooptipFormatter;
        }
      }
      props.legendData.forEach(function (item, index) {
        option.series.push({
          name: item,
          type: 'bar',
          showBackground: true,
          itemStyle: {
            color: props.colors[index]
          },
          emphasis: {
            itemStyle: {
              color: props.colors[index]
            }
          },
          data: props.lineData[index]
        });
      });
      return option;
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(BaseEchart), {
        options: _unref(options),
        height: "240px"
      }, null, 8, ["options"])]);
    };
  }
});